import { QueryClient } from "@tanstack/react-query";

import { RESUME_KEY, RESUMES_KEY } from "@/client/constants/query-keys";

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      retry: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60, // 1 minute
    },
  },
});

/** Drop cached resumes when the signed-in account changes. Query keys are not user-scoped. */
export const resetResumeQueries = () => {
  queryClient.removeQueries({ queryKey: RESUMES_KEY });
  queryClient.removeQueries({ queryKey: RESUME_KEY });
};
